import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Col, Form } from "react-bootstrap";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import UploadFiles from "../../components/UploadFiles/UploadFiles";
import { DateLabel } from "../../components/Labels";
import messages from "../../assets/i18n";
import { withRouter } from "react-router-dom";
import "./SustainabilityCertificatePage.scss";
import { HeaderActions, FooterActions, LoadingSpinner, ToastMessage } from "../../components";
import { bindActionCreators } from "redux";
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS, MISTO, NATUREZAPEDIDO } from '../../utils/constants';
import { Creators as actionsConciliationResult } from '../../store/ducks/conciliationResult'
import havePermission from '../../utils/havePermission'

class SustainabilityCertificatePage extends Component {
	pageBack = () => {
		this.props.history.push(`/main`);
	};

	constructor(props) {
		super(props);
		this.state = {
			uploadedFile: null,
			secondUploadedFile: null,
			formError: null,
			formMessage: { type: "error", message: "" },
			isLoading: false,
			sustainabilityStep: '',
			toastShow: false,
			certificateMaterialCode: '',
			expeditionDate: '',
			showSaveButton: false,
			showAlgodaoForm: true,
			descriptionUDA: ''			
		};
	}

	setToastShow = (newShow) => {
		this.setState({toastShow: newShow})
	}

	buttonGroupLeft = () => {
		return <>
			{true ? (
				<ButtonStandard
					id="algodao_button"
					text={'Algodão BCI'}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					disabled={this.state.showAlgodaoForm}
					onClick={() => this.setState({showAlgodaoForm: true})}
				/>
			) : null}

			{true ? (
				<ButtonStandard
					id="demais_atributos_button"
					text={'Demais Atributos Sustentáveis'}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					disabled={!this.state.showAlgodaoForm}
					onClick={() => this.setState({showAlgodaoForm: false})}
				/>
			) : null}
		</>
	}

	validateAndStoreLocalFile = file => {
		const { lang } = this.props;

		this.props.resetReconcile();

		this.setState({
			firstStep: '',
			uploadedFile: null,
			formMessage: {
				type: "error",
				message: ""
			}
		});

		if (file.length === 0) {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].mustBePDF
				}
			});
		}

		if (file.length > 1) {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].sendInvoice
				}
			});
		}

		file = file[0];
		if (file && file.type !== "application/pdf") {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].mustBePDF
				}
			});
		}

		this.props.conciliationResult.fileCertificateSustainability = null;

		this.setState({
			uploadedFile: file 
		});
	};

	validateAndStoreMultiFile = (file, index) => {
		const { lang } = this.props;

		this.props.resetReconcile();

		this.setState({
			firstStep: '',
			secondUploadedFile: null,
			formMessage: {
				type: "error",
				message: ""
			}
		});

		if (file.length === 0) {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].mustBePDF
				}
			});
		}

		if (file.length > 1) {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].sendInvoice
				}
			});
		}

		file = file[0];
		if (file && file.type !== "application/pdf") {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].mustBePDF
				}
			});
		}

		this.props.conciliationResult.fileCertificateSustainability = null;
		this.setState({
			secondUploadedFile: file 
		});
	};


	uploadCertificate = (file, orderId, defaultUDA) => {
		if (this.state.uploadedFile) {

			let reader = new FileReader();
			reader.readAsBinaryString(file);

			// read the file content
			reader.onload = () => {
				let base64 = new FileReader();
				base64.readAsDataURL(file);

				base64.onload = () => {
					file.result = base64.result.split(',')[1];
				}

				if (this.state.showSaveButton) {
					this.setState({
						isLoading: true
					})
				} else {
					this.setState({
						sustainabilityStep: true,
						isLoading: true
					})
				}

				this.props.dispatchSustainabilityCertificate(file, orderId, this.state.certificateMaterialCode, this.state.expeditionDate);

				if (this.state.secondUploadedFile) {
					let secondFile = this.state.secondUploadedFile
					let reader = new FileReader();
					reader.readAsBinaryString(secondFile);
		
					// read the file content
					reader.onload = () => {
						let base64 = new FileReader();
						base64.readAsDataURL(secondFile);
		
						base64.onload = () => {
							secondFile.result = base64.result.split(',')[1];
						}
		
						if (this.state.showSaveButton) {
							this.setState({
								isLoading: true
							})
						} else {
							this.setState({
								sustainabilityStep: true,
								isLoading: true
							})
						}

						let certificateMaterial = defaultUDA === ALGODAO_BCI ? '' : this.state.certificateMaterialCode
						let expeditionDate = defaultUDA === ALGODAO_BCI ? this.state.expeditionDate : ''
						this.props.dispatchSecondSustainabilityCertificate(secondFile, orderId, certificateMaterial, expeditionDate);			
					};
				}

				if (!this.state.showSaveButton) {
					this.props.dispatchSustainabilityStep(true)
				}				
			};
		}
	};

	componentDidMount = () => {
		if (this.props.history.location.from === "/conciliation-status") {
			this.setState({showSaveButton: true})
		} else {
			this.setState({showSaveButton: false})
		}

		
		if (this.props.orderList && this.props.orderList[0] ) {
			this.props.dispatchUdaDescription(this.props.orderList[0])
			this.props.dispatchConciliationResult(this.props.orderList[0])
			this.props.dispatchLastCertificateSustainability(this.props.orderList[0])
		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (this.props !== prevProps) {
			this.testReconciledSuccessfully();
		}

		if (this.state.sustainabilityStep !== prevState.sustainabilityStep && this.state.sustainabilityStep === true) {
			const order = this.props.orderList[0] ? this.props.orderList[0] : [];

			if (order.fornecedor.exigirDeclProdutor && order.empresa.exigirDeclProdutor && order.naturezaPedido === NATUREZAPEDIDO.NORMAL) {
				this.props.history.push('/producer-declaration');
			} else {
				this.props.history.push('/reconcile');
			}
		}
	};

	testReconciledSuccessfully = () => {

		const { tradeConciliation, taxConciliation } = this.props

		if (this.state.uploadedFile) {

			if (tradeConciliation === false) {
				this.setToastShow(true);
				this.setState({
					isLoading: false,
					formMessage: {
						type: "error",
						message: messages[this.props.lang.name].reconcileError
					}
				})
			}

			if (taxConciliation !== "") {
				this.setState({
					isLoading: false
				})
			}

			if (tradeConciliation === true && taxConciliation === true) {
				this.setToastShow(true);
				this.setState({
					isLoading: false,
					formMessage: {
						type: "success",
						message: messages[this.props.lang.name].reconcileSuccess
					}
				})
			} else if (tradeConciliation === true && taxConciliation === false) {
				this.setToastShow(true);
				this.setState({
					isLoading: false,
					formMessage: {
						type: "error",
						message: messages[this.props.lang.name].reconcileError
					}
				})
			}

		} else {
			this.setState({
				isLoading: false
			})
		};
	};

	removeFile = () => {
		this.setState({
			sustainabilityStep: '',
			uploadedFile: '',
			formMessage: { type: "error", message: "" },
		});
		this.props.dispatchSustainabilityStep('')
		this.props.resetReconcile()
	};

	removeMultiFile = () => {
		this.setState({
			sustainabilityStep: '',
			secondUploadedFile: '',
			formMessage: { type: "error", message: "" },
		});
		this.props.dispatchSustainabilityStep('')
		this.props.resetReconcile()
	};

	downloadFile = () => {
		const { uploadedFile } = this.state;
		let reader = new FileReader();
		reader.readAsBinaryString(uploadedFile);
		reader.onload = () => {
			let base64 = new FileReader();
			base64.readAsDataURL(uploadedFile);
			base64.onload = () => {
				const downloadLink = document.createElement("a");
				downloadLink.href = base64.result;
				downloadLink.download = uploadedFile.name;
				downloadLink.click();
			}
		};		
	};

	downloadMultiFile = () => {
		const { secondUploadedFile } = this.state;
		let reader = new FileReader();
		reader.readAsBinaryString(secondUploadedFile);
		reader.onload = () => {
			let base64 = new FileReader();
			base64.readAsDataURL(secondUploadedFile);
			base64.onload = () => {
				const downloadLink = document.createElement("a");
				downloadLink.href = base64.result;
				downloadLink.download = secondUploadedFile.name;
				downloadLink.click();
			}
		};		
	};

	titlePage = (order) => {
		const { lang } = this.props;
		return (
			<>
				{messages[lang].sustainabilityCertificate}
				<span className="ml-2 font-weight-normal word-spacing-25">
				{order.id} - {order.calendarioComercial ? order.calendarioComercial.semanaComercial : ''}
				  {" | "} 
					<DateLabel date={new Date(order.dtEmissao)}	/>
					{" "} 
					<span className="word-spacing-0">
						{order.qtCompra} {messages[lang].parts}
					</span>
				</span>
			</>
		)
	}

	setCertificateMaterialCode = (value) => {
		this.setState({
			certificateMaterialCode: value		
		})
	}

	buttonSustainability = (order, file, isLoading, permissions, defaultUDA) => () => (
		<ButtonStandard
			id="reconcile_reconcile_button"
			disabled={
				!havePermission('sustainability-add-file', permissions) ||
				!this.state.uploadedFile ||
					this.state.formMessage.message ||
					(this.state.certificateMaterialCode === '' && this.state.expeditionDate.length !== 10) 
					? true
					: false
			}
			text={this.state.showSaveButton ? messages[this.props.lang].save : messages[this.props.lang].next}
			textClass="text-3"
			isLoading={isLoading}
			className="btn btn-primary px-3 py-2 btn-light"
			onClick={() => this.uploadCertificate(file, order.id, defaultUDA)}
		/>
	)

	handleValueExpeditionDate = (value) => {
		if(value.length > 10){
			value = "0000-00-00";
		}
		this.setState({
			expeditionDate: value	
		})
	}

	convertBase64ToFile = (image) => {
		const { lang } = this.props;
		const byteString = atob(image);
		const ab = new ArrayBuffer(byteString.length);
		const ia = new Uint8Array(ab);
		for (let i = 0; i < byteString.length; i += 1) {
		  ia[i] = byteString.charCodeAt(i);
		}
		const filename = messages ? messages[lang].filePDFSustainabilityCertificate : "file.pdf"
		return new File([ab], filename,  {
		  type: 'application/pdf',
		});
	 };

	render() {
		const { permissions } = this.props
		const { uploadedFile } = this.state;
		const { orderList } = this.props;
		const { fileCertificateSustainability, defaultUDA, udaDescription } = this.props.conciliationResult;

		const order = orderList[0] ? orderList[0] : [];
		const { lang } = this.props;
		const ACCEPT_TYPE = 'application/pdf';
		const isLoading = this.props.conciliationResult.isLoading || this.props.conciliationResult.isLoadingFileCertificateSustainability;

		if (fileCertificateSustainability && !uploadedFile) {
			if (fileCertificateSustainability.payload) {

				if (fileCertificateSustainability.uda) {
					this.setState({descriptionUDA: fileCertificateSustainability.uda})
				} else if (fileCertificateSustainability.udaSecondFile) {
					this.setState({descriptionUDA: fileCertificateSustainability.udaSecondFile})
				}

				if (defaultUDA === ALGODAO_BCI) {
					this.setState({showAlgodaoForm: true})
				} else {
					this.setState({showAlgodaoForm: false})
				}

				this.validateAndStoreLocalFile([this.convertBase64ToFile(fileCertificateSustainability.payload)])

				if (fileCertificateSustainability.payloadSecondFile) {
					this.validateAndStoreMultiFile([this.convertBase64ToFile(fileCertificateSustainability.payloadSecondFile)])					
				}
			}			
		}

		return (
			<div className="page-reconcile">
				<ToastMessage 
					show={this.state.toastShow} 
					setShow={this.setToastShow} 
					message={this.state.formMessage.message}
					toastClass={this.state.formMessage.type === 'success' ? 'toast-success' : 'toast-error' }  />
				<HeaderActions pageBack={this.pageBack} titlePage={this.titlePage(order)} />

				{
					(isLoading) && <LoadingSpinner />
				}

				{
					(!isLoading && order.sustentabilidade !== MISTO) &&
					<Container className="pt-3 justify-content-start align-left mt-1 pt-1 mb-4">
						<Form.Group className="mt-2">
							<Form.Label>Descrição da UDA: {udaDescription ? udaDescription : (this.state.descriptionUDA ? this.state.descriptionUDA : (order.sustentabilidade === ALGODAO_BCI ? 'Algodão certificado BCI' : ''))}</Form.Label>
							<UploadFiles
									validateAndStoreLocalFile={this.validateAndStoreLocalFile}
									uploadedFile={this.state.uploadedFile}
									removeFile={this.state.formMessage.type !== "success" ? this.removeFile : null}
									downloadFile={this.state.uploadedFile != null ? this.downloadFile : null}
									accept={ACCEPT_TYPE}
								/>
						</Form.Group>
					</Container>
				}

				{
					!isLoading && order.sustentabilidade === MISTO
						?
						this.state.showAlgodaoForm
							?
							<Container className="pt-3 justify-content-start align-left mt-1 pt-1 mb-4">
								<Form.Group className="mt-2">
									<Form.Label>Descrição da UDA: Algodão certificado BCI</Form.Label>
									<UploadFiles
											validateAndStoreLocalFile={defaultUDA === ALGODAO_BCI ? this.validateAndStoreLocalFile : this.validateAndStoreMultiFile}
											uploadedFile={defaultUDA === ALGODAO_BCI ? this.state.uploadedFile : this.state.secondUploadedFile}
											removeFile={this.state.formMessage.type !== "success" ? (defaultUDA === ALGODAO_BCI ? this.removeFile : this.removeMultiFile) : null}
											downloadFile={this.state.uploadedFile != null ? (defaultUDA === ALGODAO_BCI ? this.downloadFile : this.downloadMultiFile) : null}
											accept={ACCEPT_TYPE}
										/>
								</Form.Group>
							</Container>
							:
							<Container className="pt-3 justify-content-start align-left mt-1 pt-1 mb-4">
								<Form.Group className="mt-2">
									<Form.Label>Descrição da UDA: {udaDescription ? udaDescription : this.state.descriptionUDA}</Form.Label>
									<UploadFiles
											validateAndStoreLocalFile={defaultUDA === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? this.validateAndStoreLocalFile : this.validateAndStoreMultiFile}
											uploadedFile={defaultUDA === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? this.state.uploadedFile : this.state.secondUploadedFile}
											removeFile={this.state.formMessage.type !== "success" ? (defaultUDA === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? this.removeFile : this.removeMultiFile) : null}
											downloadFile={this.state.uploadedFile != null ? (defaultUDA === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? this.downloadFile : this.downloadMultiFile) : null}
											accept={ACCEPT_TYPE}
										/>
								</Form.Group>
							</Container>
						:
						null
										
				}

				{
					(!isLoading && (order.sustentabilidade === ALGODAO_BCI || (order.sustentabilidade === MISTO && this.state.showAlgodaoForm))) && 
					<Container className="py-2 px-2 justify-content-between align-left">
						<Form.Row className="px-1">
						<Col>
							<Form.Group className="mt-2">
							<Form.Label>{messages[lang].certificateMaterialCode}:</Form.Label>
							<Form.Control
								className="text-2 border-radius-full"
								type="text"
								value={this.state.certificateMaterialCode}
								onChange={event => this.setCertificateMaterialCode(event.target.value)}
							/>
							</Form.Group>
						</Col>
						</Form.Row>
					</Container>
				}

				{
					(!isLoading && (order.sustentabilidade === DEMAIS_ATRIBUTOS_SUSTENTAVEIS || (order.sustentabilidade === MISTO && !this.state.showAlgodaoForm))) && 
					<Container className="py-2 px-2 justify-content-between align-left remove-bottom-padding">
						<Form.Row className="px-1">
						<Col>
							<Form.Group className="mb-3 mt-0">
							<Form.Label>{messages[lang].expeditionDate}:</Form.Label>
							<Form.Control
								className="col-3"
								type="date"
								value={this.state.expeditionDate}
								onChange={event => this.handleValueExpeditionDate(event.target.value)}
							/>
							</Form.Group>
						</Col>
						</Form.Row>
					</Container>
				}

				{
					order.sustentabilidade === MISTO
					?
					<FooterActions 
						ButtonGroupLeft={this.buttonGroupLeft}
						ButtonGroupRight={this.buttonSustainability(order, uploadedFile, isLoading, permissions, defaultUDA)} />
					:
					<FooterActions ButtonGroupRight={this.buttonSustainability(order, uploadedFile, isLoading, permissions, defaultUDA)} />
				}

			</div>
		);
	}
}

const mapStateToProps = state => ({
	orderList: state.orderList,
	lang: state.language.name,
	conciliationResult: state.conciliationResult,
	permissions: state.authorization.permissions,
});

const mapDispatchToProps = dispatch => {
	return {
		dispatchSustainabilityCertificate: (file, orderId, certificateMaterialCode, expeditionDate) =>
			dispatch({
				type: "SUSTAINABILITY_CERTIFICATE_REQUEST",
				file: file,
				orderId: orderId,
				certificateMaterialCode: certificateMaterialCode,
				expeditionDate: expeditionDate
			}),
		dispatchSecondSustainabilityCertificate: (file, orderId, certificateMaterialCode, expeditionDate) =>
			dispatch({
				type: "SECOND_SUSTAINABILITY_CERTIFICATE_REQUEST",
				file: file,
				orderId: orderId,
				certificateMaterialCode: certificateMaterialCode,
				expeditionDate: expeditionDate
		}),
		dispatchConciliation: (file, orderId) =>
			dispatch({
				type: "CONCILIATION_REQUEST",
				file: file,
				orderId: orderId
			}),
		resetReconcile: () =>
			dispatch({
				type: "RESET_RECONCILE"
			}),
		dispatchSustainabilityStep: (sustainabilityStep) =>
			dispatch({
				type: "FILE_STEP",
				sustainabilityStep: sustainabilityStep
			}),
		dispatchConciliationResult: (order) => {
			return dispatch({
				type: "GET_CONCILIATION_RESULT",
				payload: order
			})},
		dispatchLastCertificateSustainability: (order) => {
			return dispatch({
				type: "GET_LAST_CERTIFICATE_SUSTAINABILITY",
				payload: order
			})},
		dispatchUdaDescription: (orderId) => {
			return dispatch({
				type: "GET_UDA_DESCRIPTION",
				orderId: orderId
			})},
		dispatchConciliationResultClean: bindActionCreators(actionsConciliationResult.conciliationResultClean, dispatch)
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(SustainabilityCertificatePage)
);
